<template>
  <v-card height="100%">
    <project-flow-navigation-toolbar
      :title="projectName"
    ></project-flow-navigation-toolbar>
    <v-card-text style="height: calc(100% - 116px)">
      <div
        @drop.prevent="addFile"
        @dragover.prevent
        class="drop-area media-mamager"
      >
        <span>Drop a file to upload</span>
        <span>or</span>
        <v-btn small @click="upload" class="mr-2 mt-2 mb-2">
          Select a file to upload
          <v-icon right>mdi-file-plus-outline</v-icon>
        </v-btn>
        <span>or</span>
        <v-text-field
          v-model="editedItem.url"
          hide-details
          label="Enter image URL"
          style="min-width: 400px; flex: none"
          append-icon="mdi-plus"
          @click:append="addItemUrl"
        ></v-text-field>
        <!-- <v-btn small @click="upload" class="mr-2 mt-2 mb-2">
          ENTER IMAGE URLS TO ADD
          <v-icon right>mdi-file-plus-outline</v-icon>
        </v-btn> -->
      </div>
      <v-container class="pa-0 mt-5" fluid grid-list-md v-if="gridViewMedia">
        <v-layout row wrap>
          <v-flex
            xs12
            md6
            lg3
            v-for="(item, index) in editedItems"
            :key="index"
          >
            <media-card-image-preview
              :preview="item"
              @delete="removeItem(index)"
            ></media-card-image-preview>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-card-actions class="pl-5 pr-5 pb-4">
      <v-spacer></v-spacer>
      <v-btn small @click="cancel">Cancel</v-btn>
      <v-btn small color="primary darken-1" @click="save">Save</v-btn>
    </v-card-actions>
    <upload-dialog
      :showDialog="uploadDialogVisible"
      @done="uploadDialogOnDone"
      @cancel="uploadDialogVisible = false"
    ></upload-dialog>
  </v-card>
</template>

<script>
import MediaCardImagePreview from '../components/MediaCards/MediaCardImagePreview'
import { FilesGetMixin } from '../mixins/FilesGetMixin'
import UploadDialog from '../components/UploadDialog'
import ProjectFlowNavigationToolbar from '../components/AppBar/ProjectFlowNavigationToolbar'
export default {
  name: 'MediaManagerAdd',
  mixins: [FilesGetMixin],
  components: {
    ProjectFlowNavigationToolbar,
    UploadDialog,
    MediaCardImagePreview
  },
  data() {
    return {
      uploadDialogVisible: false,
      editedItems: [],
      editedItem: {
        langId: 1,
        mediaData: '',
        mediaTypeId: 3,
        name: '',
        parentGalleryId: 0,
        path: '',
        poiId: 0,
        textualContent: '',
        url: ''
      },
      gridViewMedia: true
    }
  },
  mounted() {
    this.$store.dispatch(
      'BreadcrumbsStore/add',
      {
        text: 'MEDIA MANAGER ',
        name: 'Add Media'
      },
      { root: true }
    )
  },
  methods: {
    async save() {
      if (this.editedItems.length === 0) {
        return
      }
      let list = []
      for (var i = 0; i < this.editedItems.length; i++) {
        let params = {
          langId: 1,
          mediaData: '',
          mediaTypeId: 2,
          name: this.editedItems[i].name,
          parentGalleryId: 0,
          path: this.editedItems[i].path ? this.editedItems[i].path : '',
          textualContent: '',
          url: this.editedItems[i].url ? this.editedItems[i].url : ''
        }
        list.push(params)
      }
      await this.$store.dispatch('MediaManagerStore/createMedia', list)
      await this.$store.dispatch('MediaManagerStore/resetMedia')
      await this.$store.dispatch('MediaManagerStore/resetPaging')
      this.$router.go(-1)
    },
    addItemUrl() {
      let obj = {
        name: this.editedItem.url,
        url: this.editedItem.url,
        imageData: this.editedItem.url
      }
      this.editedItems.push(obj)
      this.editedItem.url = ''
    },
    async cancel() {
      await this.$store.dispatch('MediaManagerStore/resetMedia')
      await this.$store.dispatch('MediaManagerStore/resetPaging')
      this.$router.go(-1)
    },
    upload() {
      this.uploadDialogVisible = true
    },
    removeItem(index) {
      this.editedItems.splice(index, 1)
    },
    addFile(files) {
      let fileList = files.dataTransfer.files
      if (
        fileList === null ||
        typeof fileList === 'undefined' ||
        !fileList.length
      ) {
        return
      }
      const formData = new FormData()
      for (let i = 0; i < fileList.length; i++) {
        formData.append(`file${i}`, fileList[i], fileList[i].name)
      }
      this.$store
        .dispatch('MediaStore/uploadFiles', {
          files: formData
        })
        .then(res => {
          this.uploadDialogOnDone(res)
        })
        .catch(err => {
          console.log(err)
        })
    },
    async uploadDialogOnDone(newValue) {
      this.uploadDialogVisible = false
      if (
        newValue.data &&
        Array.isArray(newValue.data) &&
        newValue.data.length > 0
      ) {
        for (var i = 0; i < newValue.data.length; i++) {
          let obj = {
            name: newValue.data[i].name,
            path: newValue.data[i].tempName
          }
          await this.getUpload(newValue.data[i].tempName).then(r => {
            obj.imageData = r
          })
          this.editedItems.push(obj)
        }
      }
    }
  },
  computed: {
    projectName: function() {
      return this.$store.state.ProjectStore.selectedProject
        ? this.$store.state.ProjectStore.selectedProject.name
        : ''
    }
  }
}
</script>

<style media="screen">
.drop-area.media-mamager {
  width: 100%;
  border: 4px dashed #ffffff;
  margin-top: 0px !important;
  border-radius: 8px;
  box-sizing: border-box;
  height: 220px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>
